import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/about/page.tsx");
